import React from "react";
import ContentLoader from "react-content-loader";

export default function ThreeDots(props) {
  return (
    <ContentLoader
      viewBox="0 0 200 160"
      height={160}
      backgroundColor="transparent"
      {...props}
    >
      <circle cx="50" cy="46" r="8" />
      <circle cx="94" cy="46" r="8" />
      <circle cx="138" cy="46" r="8" />
    </ContentLoader>
  );
}
